import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'


const getAllBuisiUsers = async (obj) => {

    let dFromF = await axios.get(ConnUrls.ApiUrl + "auth/all",  { params: obj });   

    return (dFromF.data);
}

const updateUsersList = async (obj) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "auth/upUsrlst", obj)

    return (dFromF.data);
}


const setUserBuis = async (obj) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "auth/setUsrBuis", obj)

    return (dFromF.data);
}




const buisUserLogin = async (obj) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "auth/signin", obj)

    return (dFromF.data);
}


const updatePermiss = async (obj) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "auth/upPermis", obj)

    //  await axios.get(ConnUrls.ApiUrl + "auth/signin", { "body": obj }, {

    return (dFromF.data);
}


const checkToken = async (token) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "auth/checkToken", { token })
    return (dFromF.data);
}


const buisUserChangePassword = async (obj) => {

    let dFromF = await axios.get(ConnUrls.ApiUrl + "auth/buisUserChangePassword", { params: obj });

    return (dFromF.data);
}


const buisUserChangePasswordApprove = async (newPassword, token) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "auth/ChangePasswordApprove", { newPassword, token })

    return (dFromF.data);
}


const updateBuisUser = async (nUser, token) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "auth/nUser", { nUser, token })

    return (dFromF.data);
}


const createNewBuisUsr = async (nUser, token) => {

    let dFromF = await axios.post(ConnUrls.ApiUrl + "auth/signup", { nUser, token })

    return (dFromF.data);
}

//מקבל רשימת עסקים שמיועדים למחיקה ומוחק אותם
const removeBuisList = async (obj) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "auth/removeBuisList", obj)

    return (dFromF.data);
}

export default {
    createNewBuisUsr,
    buisUserLogin,
    checkToken,
    buisUserChangePassword,
    buisUserChangePasswordApprove,
    updateBuisUser,
    getAllBuisiUsers,
    updatePermiss,
    setUserBuis,
    updateUsersList,
    removeBuisList

};